import { axiosInstance } from "./config";

const BASE_URL = '/timeslots';

export const getAllTimeslots = async () => {
  const res = await axiosInstance.get(BASE_URL);
  return res.data;
};

export const createTimeslot = async (data) => {
  const res = await axiosInstance.post(BASE_URL, data);
  return res.data;
};

export const updateTimeslot = async (id, data) => {
  const res = await axiosInstance.put(`${BASE_URL}/${id}`, data);
  return res.data;
};

export const deleteTimeslot = async (id) => {
  const res = await axiosInstance.delete(`${BASE_URL}/${id}`);
  return res.data;
};
